import { AppConfigType } from '../types/AppConfigType';

export const useConfig = (): AppConfigType => {
  const config = localStorage.getItem('Config');
  if (config !== null) {
    const appConfig: AppConfigType = JSON.parse(config);
    return { ...appConfig };
  }
  return {
    adminUrl: '',
    amFacebookAppId: '',
    apiUrl: '',
    audienceAdInsightsInternalUacProxy: '',
    audienceAdInsightsUacProxy: '',
    carFaxCallBackUrl: '',
    carFaxClientId: '',
    clientId: '',
    clientRoot: '',
    euiPerformanceInsightsInternalUacProxyUrl: '',
    euiPerformanceInsightsUacProxyUrl: '',
    firebaseApiKey: '',
    firebaseAppId: '',
    firebaseAuthDomain: '',
    firebaseMessagingSenderId: '',
    firebaseProjectId: '',
    firebaseStorageBucket: '',
    firebaseVapidKey: '',
    googleMapsApiKey: '',
    googleMapsMapId: '',
    heapAnalyticsId: '',
    inspectletWid: '',
    intercomAppId: '',
    marketImpactNewUacProxy: '',
    marketImpactSummaryUacProxyUrl: '',
    marketImpactUsedUacProxy: '',
    performanceInsightsInternalUacProxyUrl: '',
    performanceInsightsUacProxyUrl: '',
    pitchSalesPersonUrl: '',
    pitchUrl: '',
    privateIncentiveLookUp: '',
    pwaMfaTimer: '',
    servicePortfolioInternalUacProxyUrl: '',
    servicePortfolioUacProxyUrl: '',
    signalrUrl: '',
    stsAuthority: '',
    thoughtIndustriesUrl: '',
  };
};
